import { Component, type ErrorInfo, type ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { FullPageError } from "@/components/ui/system-state";

export class RouteErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Route render failed", error, info.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="flex min-h-screen w-full items-center justify-center p-6">
        <div className="w-full max-w-[640px]">
          <FullPageError
            code="500"
            codeTone="danger"
            title="Something went wrong"
            description="An unexpected error interrupted this view. You can retry the request; if it persists, contact support with the reference below."
            actions={
              <Button variant="secondary" onClick={() => this.setState({ failed: false })}>
                Try again
              </Button>
            }
          />
        </div>
      </main>
    );
  }
}
